import { baseQuery } from '../baseQuery';
import { Suburb } from 'types';

type GetAssignableServiceAreaSuburbsParams = {
  technicianId: string;
  radius: number;
};

export const getAssignableServiceAreaSuburbs = async ({
  technicianId,
  radius,
}: GetAssignableServiceAreaSuburbsParams): Promise<Suburb[]> => {
  const { data } = await baseQuery(`technicians/${technicianId}/service-areas/available?radius=${radius}`);

  return data as Suburb[];
};
